import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTower: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTower"><Path d="M9 2.5L15 2.5" stroke="currentColor"/><Path d="M12 2.5V5.5" stroke="currentColor"/><Path d="M17.5 9.5L19 5.5H5L6.5 9.5" stroke="currentColor"/><Path d="M21 9.5H3L4.99999 13.5H19L21 9.5Z" stroke="currentColor"/><Path d="M9.5 13.5L9.5 21.5H14.5V13.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconTower;
